<template>
  <div>
    <LoginDialog v-if="isShowLogin" />
    <LogoutDialog :visible="isShowLogout" @close="hideLogout()" />
    <SettingsDialog />
    <AccountDialog
      :visible="accountVisible"
      @showLogoutDialog="showLogout()"
      @hideAccountDialog="hideAccount()"
      @setTradePassword="setTradePassword"
      @openVirtual="openVirtual"
    />
    <SetTransactionPwd
      :visible="isShowSetTransactionPwd"
      @close="isShowSetTransactionPwd = false"
    />
    <VirtualContract
      :visible="isShowVirtualContract"
      @close="isShowVirtualContract = false"
    />
    <MessageCenter v-if="msgBoxVisible" @hideMessageBox="hideMessages" />
  </div>
</template>

<script>
import LoginDialog from 'mod/Login'
import LogoutDialog from 'mod/Logout'
import * as types from 'store/mutation-types'
import bus from 'src/eventbus'
import { mapGetters } from 'vuex'

export default {
  name: 'MenuSettings',
  components: {
    LoginDialog,
    LogoutDialog,
    SettingsDialog: () => import('views/Settings'),
    AccountDialog: () => import('mod/AccountInfo'),
    SetTransactionPwd: () => import('mod/SetTransactionPwd'),
    VirtualContract: () => import('mod/AccountInfo/VirtualContract'),
    MessageCenter: () => import('mod/MessageCenter')
  },
  data: () => ({
    isShowLogout: false,
    isShowSetTransactionPwd: false,
    isShowVirtualContract: false
  }),
  computed: {
    ...mapGetters(['isLogin', 'msgBoxVisible', 'accountVisible']),
    isShowLogin() {
      return !this.isLogin
    }
  },
  mounted() {
    bus.on(bus.$events.SHOW_ACCOUNT_INFO, this.showAccount)
    // 横条点击需要关闭消息弹框
    bus.on(bus.$events.CLOSE_MESSAGE_BOX, this.hideMessages)
  },
  methods: {
    setTradePassword() {
      this.hideAccount()
      this.isShowSetTransactionPwd = true
    },
    // 账户信息
    showAccount() {
      this.$store.commit(types.UPDATE_ACCOUNT_VISIBLE, true)
    },
    hideAccount() {
      this.$store.commit(types.UPDATE_ACCOUNT_VISIBLE, false)
    },
    // 消息提醒
    showMessages() {
      this.$store.commit(types.UPDATE_MSG_VISIBLE, true)
    },
    hideMessages() {
      this.$store.commit(types.UPDATE_MSG_VISIBLE, false)
    },
    showLogout() {
      this.isShowLogout = true
      this.hideAccount()
    },
    hideLogout() {
      this.isShowLogout = false
    },
    openVirtual() {
      this.hideAccount()
      this.isShowVirtualContract = true
    }
  }
}
</script>
